<div class="add-reading-room-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <div class="heading-wrapper">
    @if (!isLoading) {
      @if (!readingRoomId) {
        <h4>{{ 'pages.readingRoom.titleAdd' | translate }}</h4>
      } @else {
        <h4>
          {{ 'pages.readingRoom.titleEdit' | translate }} -
          {{ readingRoom?.name ?? '-' }}
        </h4>
      }
      <div class="actions">
        <button class="primary add-btn" (click)="submit()">
          {{ readingRoomId ? ('pages.readingRoom.submitEdit' | translate) : ('pages.readingRoom.submitAdd' | translate) }}
        </button>
        @if (readingRoomId && checkClaims(CLAIM_SCOPES['readingRoom'], CLAIM_TYPES['delete'])) {
          <button class="secondary delete-btn" (click)="openConfirmModal()">
            <img src="assets/images/delete-icon.svg" alt="delete icon" />
            {{ 'pages.readingRoom.delete' | translate }}
          </button>
        }
        <button class="secondary back-btn" (click)="back()">
          {{ 'pages.readingRoom.back' | translate }}
        </button>
      </div>
    }
  </div>
  @if (!isLoading) {
    <form class="reading-room-form" [formGroup]="form">
      <div class="main-info section">
        <div class="input-grid-first">
          <div>
            <label class="form-label lna" for="name">
              {{ 'pages.readingRoom.name' | translate }}
              <span class="required-field">*</span>
            </label>
            <input
              class="form-control lna"
              id="name"
              [ngClass]="{
                invalid: this.shouldRenderError('name', 0) && name?.errors
              }"
              type="text"
              formControlName="name"
              name="name" />
            <div class="error-wrapper">
              @if (this.shouldRenderError('name', 0) && name?.errors) {
                @if (name?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (name?.errors?.['minlength']) {
                  <small class="error-message">
                    {{
                      'components.form.minLength'
                        | translate
                          : {
                              name: name?.errors?.['minlength']['requiredLength']
                            }
                    }}
                  </small>
                } @else if (name?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{
                      'components.form.maxLength'
                        | translate
                          : {
                              maxLength: name?.errors?.['maxlength']['requiredLength']
                            }
                    }}
                  </small>
                }
              }
            </div>
          </div>
          <div>
            <label class="form-label lna" for="nameEn">
              {{ 'pages.readingRoom.nameEn' | translate }}
              <span class="required-field">*</span>
            </label>
            <input
              class="form-control lna"
              id="name"
              [ngClass]="{
                invalid: this.shouldRenderError('nameEn', 0) && nameEn?.errors
              }"
              type="text"
              formControlName="nameEn"
              name="name"
              required />
            <div class="error-wrapper">
              @if (this.shouldRenderError('nameEn', 0) && nameEn?.errors) {
                @if (nameEn?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (nameEn?.errors?.['minlength']) {
                  <small class="error-message">
                    {{
                      'components.form.minLength'
                        | translate
                          : {
                              name: nameEn?.errors?.['minlength']['requiredLength']
                            }
                    }}
                  </small>
                } @else if (nameEn?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{
                      'components.form.maxLength'
                        | translate
                          : {
                              maxLength: name?.errors?.['maxlength']['requiredLength']
                            }
                    }}
                  </small>
                }
              }
            </div>
          </div>
        </div>
        <div class="input-grid-second">
          <div class="address-wrapper">
            <label class="form-label lna" for="address">
              {{ 'pages.readingRoom.address' | translate }}
              <span class="required-field">*</span>
            </label>
            <input
              class="form-control lna"
              id="address"
              [ngClass]="{
                invalid: this.shouldRenderError('address', 0) && address?.errors
              }"
              type="text"
              formControlName="address"
              name="address"
              required />
            <div class="error-wrapper">
              @if (this.shouldRenderError('address', 0) && address?.errors) {
                @if (address?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (address?.errors?.['minlength']) {
                  <small class="error-message">
                    {{
                      'components.form.minLength'
                        | translate
                          : {
                              minLength: address?.errors?.['minlength']['requiredLength']
                            }
                    }}
                  </small>
                } @else if (address?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{
                      'components.form.maxLength'
                        | translate
                          : {
                              maxLength: address?.errors?.['maxlength']['requiredLength']
                            }
                    }}
                  </small>
                }
              }
            </div>
          </div>
          <div>
            <div class="coordinate-label">
              <label class="form-label lna" for="coordinates">
                {{ 'pages.readingRoom.coordinates' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-map-modal (coordinatesSelected)="setCoordinates($event)" />
            </div>
            <input
              class="form-control lna"
              id="coordinates"
              [value]="getFormattedCoordinates()"
              [ngClass]="{
                invalid: this.shouldRenderError('latitude', 0) && latitude?.errors
              }"
              type="text"
              name="coordinates"
              disabled
              required />
            <div class="error-wrapper">
              @if (this.shouldRenderError('latitude', 0) && latitude?.errors) {
                @if (latitude?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                }
              }
            </div>
          </div>
        </div>
        <div class="input-grid-first">
          <div>
            <div class="label-wrapper">
              <label class="form-label lna" for="email">
                {{ 'pages.readingRoom.email' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="email" />
            </div>
            <input
              class="form-control lna"
              id="email"
              [ngClass]="{
                invalid: this.shouldRenderError('email', 0) && email?.errors
              }"
              type="text"
              formControlName="email"
              name="email"
              required />
            <div class="error-wrapper">
              @if (this.shouldRenderError('email', 0) && email?.errors) {
                @if (email?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (email?.errors?.['invalidEmail']) {
                  <small class="error-message">
                    {{ 'components.form.invalidEmail' | translate }}
                  </small>
                } @else if (email?.errors?.['minlength']) {
                  <small class="error-message">
                    {{
                      'components.form.minLength'
                        | translate
                          : {
                              minLength: email?.errors?.['minlength']['requiredLength']
                            }
                    }}
                  </small>
                } @else if (email?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{
                      'components.form.maxLength'
                        | translate
                          : {
                              maxLength: email?.errors?.['maxlength']['requiredLength']
                            }
                    }}
                  </small>
                }
              }
            </div>
          </div>
          <div>
            <div class="label-wrapper">
              <label class="form-label lna" for="contactPhone">
                {{ 'pages.readingRoom.phone' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="contactPhone" />
            </div>
            <input
              class="form-control lna"
              id="contactPhone"
              [ngClass]="{
                invalid: this.shouldRenderError('contactPhone', 0) && contactPhone?.errors
              }"
              type="text"
              formControlName="contactPhone"
              name="contactPhone"
              required />
            <div class="error-wrapper">
              @if (this.shouldRenderError('contactPhone', 0) && contactPhone?.errors) {
                @if (contactPhone?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (contactPhone?.errors?.['invalidPhone']) {
                  <small class="error-message">
                    {{ 'components.form.invalidPhone' | translate }}
                  </small>
                } @else if (contactPhone?.errors?.['minlength']) {
                  <small class="error-message">
                    {{
                      'components.form.minLength'
                        | translate
                          : {
                              minLength: contactPhone?.errors?.['minlength']['requiredLength']
                            }
                    }}
                  </small>
                } @else if (contactPhone?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{
                      'components.form.maxLength'
                        | translate
                          : {
                              maxLength: contactPhone?.errors?.['maxlength']['requiredLength']
                            }
                    }}
                  </small>
                }
              }
            </div>
          </div>
          <div>
            <div class="label-wrapper">
              <label class="form-label lna" for="imageUrl">
                {{ 'pages.readingRoom.imageUrl' | translate }}
              </label>
              <app-tooltip text="imageUrl" />
            </div>
            <input
              class="form-control lna"
              id="imageUrl"
              [ngClass]="{
                invalid: this.shouldRenderError('imageUrl', 0) && imageUrl?.errors
              }"
              type="text"
              formControlName="imageUrl"
              name="imageUrl" />
            <div class="error-wrapper"></div>
          </div>
        </div>
        <div>
          <div class="label-wrapper">
            <label class="form-label lna" for="description">
              {{ 'pages.readingRoom.description' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-tooltip text="description" />
          </div>
          <textarea
            class="form-control lna description wrap"
            id="description"
            [ngClass]="{
              invalid: this.shouldRenderError('description', 0) && description?.errors
            }"
            type="text"
            formControlName="description"
            name="description"
            required
            maxlength="{{ maxFieldLength }}"></textarea>
          <div class="d-flex justify-content-end">
            <p
              class="length"
              [ngClass]="{
                invalid: description?.value.length > maxFieldLength
              }">
              {{ description?.value?.length || 0 }}/{{ maxFieldLength }}
            </p>
          </div>
          <div class="error-wrapper">
            @if (this.shouldRenderError('description', 0) && description?.errors) {
              @if (description?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (description?.errors?.['maxlength']) {
                <small class="error-message">
                  {{
                    'components.form.maxLength'
                      | translate
                        : {
                            maxLength: description?.errors?.['maxlength']['requiredLength']
                          }
                  }}
                </small>
              }
            }
          </div>
        </div>
        <div>
          <div class="label-wrapper">
            <label class="form-label lna" for="descriptionEn">
              {{ 'pages.readingRoom.descriptionEn' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-tooltip text="descriptionEn" />
          </div>
          <textarea
            class="form-control lna description wrap"
            id="descriptionEn"
            [ngClass]="{
              invalid: this.shouldRenderError('descriptionEn', 0) && descriptionEn?.errors
            }"
            type="text"
            formControlName="descriptionEn"
            name="descriptionEn"
            required
            maxlength="{{ maxFieldLength }}"></textarea>
          <div class="d-flex justify-content-end">
            <p
              class="length"
              [ngClass]="{
                invalid: descriptionEn?.value.length > maxFieldLength
              }">
              {{ descriptionEn?.value?.length || 0 }}/{{ maxFieldLength }}
            </p>
          </div>
          <div class="error-wrapper">
            @if (this.shouldRenderError('descriptionEn', 0) && descriptionEn?.errors) {
              @if (descriptionEn?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (descriptionEn?.errors?.['maxlength']) {
                <small class="error-message">
                  {{
                    'components.form.maxLength'
                      | translate
                        : {
                            maxLength: descriptionEn?.errors?.['maxlength']['requiredLength']
                          }
                  }}
                </small>
              }
            }
          </div>
        </div>
      </div>
      <div class="working-hours section" formArrayName="scheduleEntries">
        <div class="title-row px-0">
          <div class="header-wrapper">
            <h6>{{ 'pages.readingRoom.workingHours' | translate }}</h6>
            <app-tooltip [marginBottom]="true" text="workingHours" />
          </div>
        </div>
        @for (schedule of scheduleEntries.controls; track schedule) {
          <div class="day-input" [formGroupName]="$index">
            <label class="form-label lna day-label" [for]="schedule.get('day')?.value + 'From'">
              {{ 'pages.readingRoom.' + schedule.get('day')?.value + 'Short' | translate }}
            </label>
            <app-time-input
              [time]="schedule.get('startTime')?.value"
              [invalid]="shouldRenderError('scheduleEntries', $index) && !!schedule?.errors"
              [disabled]="schedule.get('isDayOff')?.value"
              (timeChange)="onTimeChange($event, $index, 'startTime')"
              (blured)="markScheduleInputAsTouched($index, 'startTime')" />
            <span>-</span>
            <app-time-input
              [time]="schedule.get('endTime')?.value"
              [invalid]="shouldRenderError('scheduleEntries', $index) && !!schedule?.errors"
              [disabled]="schedule.get('isDayOff')?.value"
              (timeChange)="onTimeChange($event, $index, 'endTime')"
              (blured)="markScheduleInputAsTouched($index, 'endTime')" />
            <div class="checkboxes">
              <div class="checkbox-wrapper">
                <input
                  class="form-check-input lna checkbox"
                  [name]="schedule.get('day')?.value + 'Holiday'"
                  [id]="schedule.get('day')?.value + 'Holiday'"
                  type="checkbox"
                  formControlName="isDayOff" />
                <label class="form-label lna" for="holiday">
                  {{ 'pages.readingRoom.holiday' | translate }}
                </label>
              </div>
            </div>
            @if (shouldRenderError('scheduleEntries', $index) && schedule.errors) {
              @if (schedule.errors['requiredIfNotHoliday']) {
                <small class="error-message">
                  {{ 'components.form.errorRequiredIfNotHoliday' | translate }}
                </small>
              } @else if (schedule.errors['startTimeBeforeEndTime']) {
                <small class="error-message">
                  {{ 'components.form.errorStartTimeBeforeEndTime' | translate }}
                </small>
              }
            }
          </div>
        }
      </div>
      <div class="notifications section" formArrayName="notificationEntries">
        <div class="title-row">
          <div class="header-wrapper">
            <h6>{{ 'pages.readingRoom.notifications' | translate }}</h6>
            <app-tooltip [marginBottom]="false" text="notifications" />
          </div>
          <button class="secondary" (click)="addNotification()">
            <img src="assets/images/add-icon.svg" alt="add icon" />
            {{ 'pages.readingRoom.addNotification' | translate }}
          </button>
        </div>
        <div class="labels-wrapper">
          <div class="table-header_wrapper">
            <p>
              {{ 'pages.readingRoom.notificationText' | translate }}
              <span class="required-field">*</span>
            </p>
            <app-tooltip [marginBottom]="false" text="readingRoomNotificationText" [position]="'top-right'"></app-tooltip>
          </div>
          <div class="table-header_wrapper">
            <p>
              {{ 'pages.readingRoom.notificationTextEn' | translate }}
              <span class="required-field">*</span>
            </p>
            <app-tooltip [marginBottom]="false" text="readingRoomNotificationTextEn"></app-tooltip>
          </div>
          <div class="table-header_wrapper">
            <p>
              {{ 'pages.readingRoom.notificationFrom' | translate }}
              <span class="required-field">*</span>
            </p>
            <app-tooltip [marginBottom]="false" text="notificationFrom"></app-tooltip>
          </div>
          <div class="table-header_wrapper">
            <p>{{ 'pages.readingRoom.notificationTo' | translate }}</p>
            <app-tooltip [marginBottom]="false" text="notificationTo"></app-tooltip>
          </div>
        </div>
        @for (notification of notificationEntries.controls; track notification) {
          <div class="notification-input-wrapper" [formGroupName]="$index">
            <div class="description-input-wrapper">
              <textarea
                class="form-control lna wrap"
                [ngClass]="{
                  invalid: shouldRenderError('notificationEntries.text', $index) && notification.get('text')?.errors
                }"
                type="text"
                formControlName="text"
                name="notificationText"
                required></textarea>
              @if (shouldRenderError('notificationEntries.text', $index)) {
                @if (notification.get('text')?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                }
              }
            </div>
            <div class="description-input-wrapper">
              <textarea
                class="form-control lna wrap"
                [ngClass]="{
                  invalid: shouldRenderError('notificationEntries.textEn', $index) && notification.get('textEn')?.errors
                }"
                type="text"
                formControlName="textEn"
                name="readingRoomNotificationTextEn"
                required></textarea>
              @if (shouldRenderError('notificationEntries.textEn', $index)) {
                @if (notification.get('textEn')?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                }
              }
            </div>
            <div class="date-input-wrapper">
              <app-date-picker
                [date]="formatDate(notification.get('startDate')?.value)"
                [invalid]="shouldRenderError('notificationEntries.startDate', $index) && !!notification.get('startDate')?.errors"
                (dateSelected)="onNotificationDateSelected($event, $index, 'startDate')"
                (blur)="markNotificationDateAsTouched($index, 'startDate')"
                required />
              @if (shouldRenderError('notificationEntries.startDate', $index)) {
                @if (notification.get('startDate')?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                }
              }
            </div>
            <div class="date-input-wrapper">
              <app-date-picker
                [date]="formatDate(notification.get('endDate')?.value)"
                [invalid]="shouldRenderError('notificationEntries', $index) && !!notification.get('endDate')?.errors"
                (dateSelected)="onNotificationDateSelected($event, $index, 'endDate')" />
            </div>
            <div class="delete-wrapper">
              <button class="secondary delete-btn" (click)="openDeleteNotificationModal($index)">
                <img src="assets/images/delete-icon.svg" alt="remove icon" />
              </button>
            </div>
          </div>
        }
      </div>
      <div class="section additional-info">
        <div class="application-email">
          <div class="label-wrapper">
            <label class="form-label lna" for="applicationEmail">
              <span>{{ 'pages.readingRoom.applicationEmail' | translate }}</span>
              <span class="required-field">*</span>
            </label>
              <app-tooltip text="applicationEmail" />
          </div>

          <input
            class="form-control lna"
            id="applicationEmail"
            [ngClass]="{
              invalid: this.shouldRenderError('applicationEmail', 0) && applicationEmail?.errors
            }"
            type="text"
            formControlName="applicationEmail"
            name="applicationEmail"
            required />
          <div class="error-wrapper">
            @if (this.shouldRenderError('applicationEmail', 0) && applicationEmail?.errors) {
              @if (applicationEmail?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (applicationEmail?.errors?.['invalidEmail']) {
                <small class="error-message">
                  {{ 'components.form.invalidEmail' | translate }}
                </small>
              } @else if (applicationEmail?.errors?.['minlength']) {
                <small class="error-message">
                  {{
                    'components.form.minLength'
                      | translate
                        : {
                            minLength: applicationEmail?.errors?.['minlength']['requiredLength']
                          }
                  }}
                </small>
              } @else if (applicationEmail?.errors?.['maxlength']) {
                <small class="error-message">
                  {{
                    'components.form.maxLength'
                      | translate
                        : {
                            maxLength: applicationEmail?.errors?.['maxlength']['requiredLength']
                          }
                  }}
                </small>
              }
            }
          </div>
        </div>
        <div class="structural-unit">
          <div class="label-wrapper">
              <label class="form-label lna" for="strucuralUnitId">
              {{ 'pages.readingRoom.structuralUnit' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-tooltip text="structuralUnitName" />
          </div>

          <select
            id="structuralUnitId"
            [ngClass]="{
              empty: form.get('structuralUnitId')?.value === -1,
              invalid: structuralUnitId?.invalid && structuralUnitId?.touched
            }"
            [ngClass]="{
              invalid: this.shouldRenderError('structuralUnit', 0) && contactPhone?.errors
            }"
            (blur)="onStructuralUnitBlur()"
            formControlName="structuralUnitId">
            <option class="empty-option" [value]="-1" disabled>
              {{ 'pages.readingRoom.chooseStructuralUnit' | translate }}
            </option>
            @for (structuralUnit of structuralUnits; track structuralUnit.id) {
              <option [value]="structuralUnit.id">
                {{ structuralUnit.name }}
              </option>
            }
          </select>
          <div class="error-wrapper">
            @if (this.shouldRenderError('structuralUnitId', 0) && structuralUnitId?.errors) {
              @if (structuralUnitId?.errors?.['structuralUnitNotSelected']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              }
            }
          </div>
        </div>
        <div class="reading-room-code">
          <div>
            <div class="label-wrapper">
            <label class="form-label lna" for="code">
              {{ 'pages.readingRoom.code' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-tooltip text="readingRoomCode" />
            </div>
            <input
              class="form-control lna"
              id="code"
              [ngClass]="{
                invalid: this.shouldRenderError('code', 0) && code?.errors
              }"
              type="text"
              formControlName="code"
              name="code"
              required />
            <div class="error-wrapper">
              @if (this.shouldRenderError('code', 0) && code?.errors) {
                @if (code?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                } @else if (contactPhone?.errors?.['minlength']) {
                  <small class="error-message">
                    {{
                      'components.form.minLength'
                        | translate
                          : {
                              minLength: contactPhone?.errors?.['minlength']['requiredLength']
                            }
                    }}
                  </small>
                } @else if (contactPhone?.errors?.['maxlength']) {
                  <small class="error-message">
                    {{
                      'components.form.maxLength'
                        | translate
                          : {
                              maxLength: contactPhone?.errors?.['maxlength']['requiredLength']
                            }
                    }}
                  </small>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  } @else {
    <div class="loader-wrapper">
      <app-spinner [isLoading]="isLoading" />
    </div>
  }
  <app-confirm-modal [isOpen]="isOpenConfirmDeleteRoom" (confirm)="delete()" (cancel)="onModalClose()" title="deleteReadingRoom" />
  <app-confirm-modal
    [isOpen]="isOpenConfirmDeleteNotif"
    (confirm)="removeNotification(openModalIndex)"
    (cancel)="onModalClose()"
    title="deleteNotification" />
  <app-confirm-modal
    [isOpen]="isOpenConfirmBack"
    (confirm)="back(true)"
    (cancel)="onModalClose()"
    title="deleteChanges"
    confirmText="confirm"
    denyText="cancelBack" />
</div>
